module.exports = __webpack_public_path__ + "img/cloud-moon.8475bb2d.svg";